import React, { useEffect, useRef } from "react";
import CountUp from "react-countup";
import { InfiosKeyFactsItem } from "./KeyFactsItem.style";
import Icon from "../../Icon/Icon";
import { colors } from "../../../utils/styled/_variables.styled";
import { useIntersectionObserver } from "../../RelatedContentSection/hooks";

const FitText = ({ text, minFontSize = 12, maxFontSize = 80, setTitleSize, titleSize, i }) => {
  const spanRef = useRef(null);

  const adjustFontSize = () => {
    const el = spanRef.current;
    if (!el || !el.parentElement) return;

    let size = titleSize;
    el.style.fontSize = `${size}px`;

    const parent = el.parentElement;
    while (size > minFontSize && (el.scrollWidth > parent.clientWidth || el.scrollHeight > parent.clientHeight)) {
      size -= 1;
      el.style.fontSize = `${size}px`;
			setTitleSize(size);
    }

  };

	const resetAndAdjust = () => {
		setTitleSize(80);
		adjustFontSize();
	}

  useEffect(() => {
    adjustFontSize();
    window.addEventListener('resize', resetAndAdjust);
    return () => window.removeEventListener('resize', resetAndAdjust);
  }, [text, titleSize]);

	const marginRight = titleSize / 5;

  return (
    <span className={`span-item span-${i}`} ref={spanRef} style={{ display: 'inline-block', whiteSpace: 'nowrap', marginRight: `${marginRight}px` }}>
      {`${text}`}
    </span>
  );
};

const KeyFactsItem = (props) => {
	const {
		showIcon,
		endValue,
		decimals,
		suffix,
		prefix,
		subtitle,
		description,
		type,
		text,
		numberColor = "#8377D1",
		textColor = "#8377D1",
		titleSize,
		setTitleSize
	} = props;

	const titleRef = useRef(null);

	const animate = useIntersectionObserver(titleRef);

	const content = text ? text.split([" "]) : [""]

	return (
		<InfiosKeyFactsItem>
			{showIcon ? (
				<Icon
					icon="handshake"
					color={colors.lavender}
					className="handshake__icon"
				/>
			) : (
				<>
					{(!type || type === "number") && (
						<h2
							className="heading-1"
							style={{ color: numberColor || "inherit" }}
						>
							<CountUp
								decimals={decimals | 0}
								start={endValue > 10 ? 10 : 0}
								end={endValue}
								delay={0.3}
								scrollSpyDelay={300}
								enableScrollSpy={true}
								scrollSpyOnce={true}
								suffix={suffix || ""}
								prefix={prefix || ""}
								duration={3}
								redraw={true}
							/>
						</h2>
					)}
					{type === "text" && (
						<h2
							className={`heading-1 ${animate ? "active" : "inactive"}`}
							ref={titleRef}
							style={{ color: numberColor || "inherit", fontSize: `${titleSize}px` }}
						>
							{content && content.map((item, k) => {
								return (
									<FitText text={item} key={k} i={k} minFontSize={12} maxFontSize={80} setTitleSize={setTitleSize} titleSize={titleSize} />
								)
							})}
						</h2>
					)}
				</>
			)}
			{subtitle && (
				<p className="lead" style={{ color: textColor || "inherit" }}>
					{subtitle}
				</p>
			)}
			{description && <div className="separator"></div>}
			{description && (
				<p
					className="keyfacts-text p-small"
					style={{ color: textColor || "inherit" }}
				>
					{description}
				</p>
			)}
		</InfiosKeyFactsItem>
	);
};

export default KeyFactsItem;
